const fields = {
    nvic_name: {
        label: 'What is the name of the TOAR?',
        name: 'nvic_name',
    },
    nvic_completed: {
        label: 'Is this TOAR completed?',
        name: 'nvic_completed',
    },
    completed_date: {
        label: 'What day did you complete this TOAR?',
        name: 'completed_date',
    },
    assessor_info_completed: {
        label:
            'Is all of the information about the Designated Examiner(s) on the last page of this TOAR completed?',
        name: 'assessor_info_completed',
    },
};

export default fields;
